module.exports = __webpack_public_path__ + "img/mission.80af4f0a.jpg";